module.exports = __webpack_public_path__ + "img/instructions_image.9a44d286.jpg";